import { createFeatureSelector, createSelector } from '@ngrx/store';
import { ActionLogState, FEATURE_NAME } from './action-log.state';

export const selectActionLogState =
  createFeatureSelector<ActionLogState>(FEATURE_NAME);

export const selectFilteredActionLogWithCurrentPage = createSelector(
  selectActionLogState,
  (state) => {
    if (
      state.filter?.page === null ||
      state.filter?.page === undefined ||
      !state.pages[state.filter!!.page!!]
    ) {
      return [];
    }

    return (
      state.pages[state.filter!!.page!!].map((id) => state.entities[id]) ?? []
    );
  },
);

export const selectIsActionLogLoading = createSelector(
  selectActionLogState,
  (state) => state.isLoading,
);

export const selectActionLogTotalCount = createSelector(
  selectActionLogState,
  (state) => state.totalCount,
);

export const selectActionLogFilter = createSelector(
  selectActionLogState,
  (state) => state.filter,
);
